<template>
    <div v-if="buildingProcessedId > 0" class="card buildingCard">
        <div class="card-body buildingCard-body" v-bind:class="{'buildingCard-hasMap': hasGeo}">
            <div v-bind:class="{'buildingCard-infoMap': hasGeo}">
               <slot name="title"></slot>
                <dl class="card-text buildingCard-list">
                    <dt v-if="buildingStrataNo">SP/DP:</dt>
                    <dd v-if="buildingStrataNo">{{buildingStrataNo}}</dd>
                    <dt v-if="buildingName">Building Name:</dt>
                    <dd v-if="buildingName">{{buildingName}}</dd>
                    <dt v-if="buildingAddress">Building Address:</dt>
                    <dd v-if="buildingAddress">{{buildingAddress}}</dd>
                    <dt v-if="parking">Access Notes:</dt>
                    <dd v-if="parking">{{note}}</dd>
                    <dt v-if="toilet">On-site Facilities:</dt>
                    <dd v-if="toilet">{{toilet}}</dd>
                    <dt v-if="note">Notes:</dt>
                    <dd v-if="note">{{note}}</dd>
                </dl>
                <RequiresSitePermissions v-bind:required-permissions="['WRITE']" v-bind:site-id="buildingId">
                    <button
                            v-on:click="$emit('showCreateBuildingCard')"
                            class="buildingCard-edit">
                        <i class="fas fa-pen"></i>
                        <span class="sr-only">Edit</span>
                    </button>
                </RequiresSitePermissions>
            </div>
            <picture class="buildingCard-map" v-if="hasGeo">
                <source media="(max-width: 575px)" v-bind:srcset="imgSrc(13, 500, 350, 2)">
                <source media="(min-width: 576px) and (max-width: 991px)" v-bind:srcset="imgSrc(13, 400, 300, 2)">
                <source media="(min-width: 992px) and (max-width: 1199px)" v-bind:srcset="imgSrc(12, 640, 400, 1)">
                <source media="(min-width: 1200px) and (max-width: 1399px)" v-bind:srcset="imgSrc(13, 500, 280, 1)">
                <img v-bind:src="imgSrc(12, 600, 400, 1)" v-bind:alt="buildingAddress">
            </picture>
        </div>

    </div>
</template>
<style>
</style>
<script>
import RequiresSitePermissions from "@/components/RequiresSitePermissions";
import Tools from '@/app-model/tools.js';
import ToolTip from '@/components/tool-tip/ToolTip.vue'

export default {
    props: {
      buildingId: Number,
      buildingLatitude: String|Number,
      buildingLongitude: String|Number,
      buildingStrataNo: String,
      buildingName: String,
      buildingAddress: String,
      buildingStatusColor: String,
      showCreateBuildingCard: Boolean
    },
    components: {
      RequiresSitePermissions,
      ToolTip
    },
    data() {
      return {
        key: undefined,
        parking: undefined,
        toilet: undefined,
        note: undefined,
      }
    },
    computed: {
      tools: function () {
        return new Tools
      },
      hasGeo: function () {
        return (this.buildingLatitude && this.buildingLongitude) || this.buildingAddress;
      },
      buildingProcessedId: function () {
        return this.buildingId;
      }
    },
    mounted() {
      this.fetchBuildingDetails(this.buildingId);
    },
    methods: {
      imgSrc(zoom, w, h, scale) {
        return this.tools.mapImgSrc(
          [
            {
              latitude: this.buildingLatitude,
              longitude: this.buildingLongitude,
              address: this.buildingAddress,
              color: this.buildingStatusColor
            }
          ],
          zoom,
          w,
          h,
          scale
        );
      },
      fetchBuildingDetails(buildingId) {
        for (let settings of [
          ['building_key', 'key'],
          ['building_parking', 'parking'],
          ['building_toilet', 'toilet'],
          ['building_note', 'note'],
        ]) {
          this[settings[1]] = undefined;

          let data = {
            method: 'GET',
            path: `api/user-buildings/${buildingId}/${settings[0]}`,
            path_template: `/api/user-buildings/{building_id}/${settings[0]}`,
            building_id: buildingId
          };
          this.$store.dispatch('apiResult', data).then(response => {
            if (response.status === 200 && buildingId === this.buildingId) {
              this[settings[1]] = response.data.data[settings[1]];
            }
          });
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>